import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import MyForm from "components/Form";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { connect } from 'react-redux';
import { crudActions, modalActions } from '../../../_actions';
import SimpleReactValidator from 'simple-react-validator';

class UpdatePriceForm extends React.PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            btnText: 'Update',
            form: {
                price: props.resumePrice.toString(),
            },
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    }

    handleInputChange(event) {
        const { name, value } = event.target;
        const newValue = value < 0 ? 0 : value;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [name]: newValue,
            },
        }));
        this.handleError();
    }


    getFormFields = () => {
        const { form } = this.state;

        const formFields = [
            {
                name: 'price',
                label: 'Update Price',
                type: 'number',
                value: form.price,
                icon: 'attach_money',
                error: this.validator.message('price', form.price, 'required|min:0'),
            },
        ];

        return formFields;
    }

    handleError() {
        this.validator.showMessages();
        this.forceUpdate();
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            const { id, actionFor } = this.props;
            const { form } = this.state;
            const data = {
                price: form.price,
            };
            if (actionFor === 'user') {
                this.props.update('formData', 'resume-price', id, data);
            }
            this.props.closeModal();
        } else {
            this.handleError();
        }
    }

    render() {
        const { btnText } = this.state;

        return (
            <MyForm
                handleInputChange={this.handleInputChange}
                formFields={this.getFormFields()}
                handleSubmit={this.handleSubmit}
                handleCancel={this.goBack}
                btnText={btnText}
            />
        );
    }
}

UpdatePriceForm.propTypes = {
    classes: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    actionFor: PropTypes.string.isRequired,
};

function mapState(state) {
    const { confirm } = state;
    return {
        confirm
    };
}

const actionCreators = {
    update: crudActions._update,
    closeModal: modalActions.close,
};

export default withStyles(styles)(connect(mapState, actionCreators)(UpdatePriceForm));
